import React from 'react'
import Helmet from 'react-helmet'
import get from 'lodash/get'
import Img from 'gatsby-image'
import moment from 'moment'

import heroStyles from '../components/hero.module.css'
import pageStyles from '../components/page.module.css'

class FlatpageTemplate extends React.Component {
  render() {
    const post = get(this.props, 'data.contentfulPage')
    const siteData = get(this.props, 'data.site.siteMetadata')

    // console.log(post);

    return (
      <div style={{ background: '#fff' }} className="page-content">
        <Helmet title={`${post.title} | ${siteData.title}`}>

          <link rel="canonical" href={`${siteData.siteUrl}/page/${post.slug}`} />
          <meta name="description" content={`${post.excerpt}`} />
          <meta name="title" content={`${post.title} | ${siteData.title}`} />

          <meta property="og:title" content={`${post.title} | ${siteData.title}`} />
          <meta property="og:site_name" content="YOUCAT Indonesia" />
          <meta property="og:url" content={`${siteData.siteUrl}/page/${post.slug}`} />
          <meta property="og:description" content={`${post.excerpt}`}  />
          <meta property="og:image" content="https://static.youcat.id/ogimg/ogimg-youcat.png" />
          <meta property="og:locale" content="id_ID" />
          <meta property="og:type" content="website" />

        </Helmet>
        <div className={`wrapper page-${post.slug}`}>
          <h1 className={`page-title`}>{post.title}</h1>
          <div
            dangerouslySetInnerHTML={{
              __html: post.body.childMarkdownRemark.html,
            }}
          />
        </div>
      </div>
    )
  }
}

export default FlatpageTemplate

export const pageQuery = graphql`
  query FlatpageBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        siteUrl
        siteImg
      }
    }
    contentfulPage(slug: { eq: $slug }) {
      title
      slug
      excerpt
      body {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/flatpage-post.js